import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {Router} from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { RequestsHandler } from './requests.service';
import {Api} from '../utils';

@Injectable()
export class PackagesRules {

    constructor(private _http: HttpClient,
                private api: Api,
                private router: Router,
                private handler: RequestsHandler) { }

    getPackages() {
        return this._http
            .get(this.api.getUrl('admin/pack_rules'), {headers: this.handler.headers()})
            .catch((err: any) => {
                this.handler.handleError(err);
                return Observable.throw(new Error(err));
            });
    }

    setPackage(id, data) {
        return this._http
            .put(this.api.getUrl('admin/package_update/' + id),  JSON.stringify(data), {headers: this.handler.headers()})
            .catch((err: any) => {
                this.handler.handleError(err);
                return Observable.throw(new Error(err));
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/packages-rules.service.ts